/**
 * US Social Security number input helpers, shared by every form that collects
 * one so the mask, the stored shape and the validity rule cannot drift.
 */
/** Display mask for an SSN input (`XXX-XX-XXXX`); `_` marks a digit slot. */
const SSN_MASK = '___-__-____';
const SSN_DIGIT_COUNT = 9;
/**
 * The SSN as stored: digits only, at most nine. A Rev `TextInput` mask formats
 * the display but still reports characters past its last slot, so an input's
 * `onChange` passes its value through this before storing it.
 */
function toSsnDigits(value) {
    return value.replaceAll(/\D/g, '').slice(0, SSN_DIGIT_COUNT);
}
/** True when the value is exactly nine digits, with or without dashes. */
function isValidSsn(value) {
    return /^\d{9}$/.test(value.replaceAll('-', ''));
}
/**
 * Marks an SSN a saved Express session holds as RSA ciphertext (the same
 * encryption an order's credit application uses) rather than digits. A session
 * is stored where its id alone reads it back, so it never holds the digits.
 */
const SESSION_SSN_CIPHERTEXT_PREFIX = 'rsa-oaep:';
/** True when a session SSN is ciphertext written by `toSessionSsnCiphertext`. */
function isSessionSsnCiphertext(value) {
    return typeof value === 'string' && value.startsWith(SESSION_SSN_CIPHERTEXT_PREFIX);
}
/** Wraps base64 RSA ciphertext of an SSN for storage in a session. */
function toSessionSsnCiphertext(ciphertext) {
    return `${SESSION_SSN_CIPHERTEXT_PREFIX}${ciphertext}`;
}
/**
 * The base64 ciphertext a session SSN holds, as an order's credit application
 * stores it, or null when the value is not session ciphertext.
 */
function sessionSsnCiphertextOf(value) {
    if (typeof value !== 'string' || !isSessionSsnCiphertext(value))
        return null;
    return value.slice(SESSION_SSN_CIPHERTEXT_PREFIX.length);
}

export { SESSION_SSN_CIPHERTEXT_PREFIX, SSN_MASK, isSessionSsnCiphertext, isValidSsn, sessionSsnCiphertextOf, toSessionSsnCiphertext, toSsnDigits };
//# sourceMappingURL=ssn.js.map
